// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
let apiPre = sysConfig.apiPre
export default {
     // 电表启动配置分页
     inOrUpdate(params) {
       console.log('params:' + JSON.stringify(params))
       return http.requestPost(apiPre + service.res + '/res/meterAcquisitionTerminal/insertOrUpdateTerminal', params)
     },

     getMeterAcquisitionTerminalByStationId(params) {

       return http.requestGet(apiPre + service.res + '/res/meterAcquisitionTerminal/getMeterAcquisitionTerminalByStationId/'+params)
     },

     deleteTerminal(params) {
       console.log('params:' + JSON.stringify(params))
       return http.requestDelete(apiPre + service.res + '/res/meterAcquisitionTerminal/deleteByid/'+params)
     },
     queryAll(params) {
       return http.requestPut(apiPre + service.res + '/res/meterAcquisitionTerminal/getQueryAllPage', params)
     },
     getMeterCodeList(params){
        return http.requestGet(apiPre + service.res +'/res/meter/getMeterCodeBystationId/'+params)
     },

     meterFiltration(params){
       return http.requestGet(apiPre + service.res +'/res/meter/meterFiltration/'+params)
     }
  }



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/meterAcquisitionTerminalApi.js